import React from 'react';
import posthog from 'posthog-js';
import SupplierServiceCallCalendarPage from './SupplierServiceCallCalendarPage';
import SupplierServiceCallCalendarPageV2 from './SupplierServiceCallCalendarPageV2';

const SupplierServiceCallCalendarPageIndex = (props: any) => {
	const isFeatureEnabled = posthog.isFeatureEnabled('service-calendar-v2');

	const Component: any = isFeatureEnabled
		? SupplierServiceCallCalendarPageV2
		: SupplierServiceCallCalendarPage;
	return <Component {...props} />;
};

export default SupplierServiceCallCalendarPageIndex;
